<div class="view-reminder-dialog">
    <div mat-dialog-title oneDialogTitle>
      <span>Reminders</span>
    </div>
    <div class="reminder-overview-details">
        <div class="cd-item">
        <div class="cd-title">Notification subject</div>
        <div class="cd-value">{{ notificationData.MessageTitle }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Notification sent</div>
        <div class="cd-value">{{ appUtils.formatDateWithTime(customerData.DateSent) }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Feedback due date</div>
        <div class="cd-value">{{ appUtils.formatDateWithTime(notificationData.FeedbackDueDate) }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Last reminder sent</div>
        <div class="cd-value">{{ getLastReminderSent() }}</div>
        </div>
    </div>
    <div class="reminder-table-title">
      <span>Scheduled reminders for this notification</span>
    </div>
    <div mat-dialog-content oneDialogContent class="reminder-dialog-content">
      <div class="reminder-table-data">
        <one-table>
          <one-table-content class="reminder-table-scrollable">
            <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="reminder-tbl" >
              <ng-container matColumnDef="ReminderSubject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header title="Reminder subject"><span>Reminder subject</span></th>
                <td mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.ReminderSubject">{{ element.ReminderSubject }}</div>
                </td>
              </ng-container>
                
              <ng-container matColumnDef="ReminderSendDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header title="Date sent"><span>Date sent</span></th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.ReminderSendDate" class="truncate-text" [title]="element.ReminderSendDate">{{ appUtils.formatDateWithTime(element.ReminderSendDate) }}</div>
                  <div *ngIf="element.ReminderDeliveryFailedDate" class="truncate-text" [title]="element.ReminderDeliveryFailedDate">{{ appUtils.formatDateWithTime(element.ReminderDeliveryFailedDate) }}</div>
                  <span *ngIf="!element.ReminderSendDate && !element.ReminderDeliveryFailedDate" >--</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="ReminderDueDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header title="Reminder scheduled date"><span>Reminder scheduled date</span></th>
                <td mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.ReminderDueDate">{{ element.ReminderDueDate }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="ReminderSendStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header title="Status"><span>Status</span></th>
                <td mat-cell *matCellDef="let element">
                  <mat-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline"> {{ displayStatus(element.ReminderSendStatus) }}</mat-chip>
                  <!-- <i class="one-icons icon-chevron" title="Click to Expand/Collapse row"> </i> -->
                </td>
              </ng-container>

              <ng-container matColumnDef="expandTrigger">
                <th mat-header-cell *matHeaderCellDef title="Expand/Collapse"></th>
                <td mat-cell (click)="expandToggle(element)" *matCellDef="let element">
                  <button *ngIf="element == expandedElement" one-icon-button mat-icon-button>
                    <mat-icon>arrow_up</mat-icon>
                  </button>
                  <button *ngIf="element != expandedElement" one-icon-button mat-icon-button>
                    <mat-icon>arrow_down</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <div class="reminder-element-detail"
                        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" class="one-element-detail">
                    <div class="one-element-detail-content mat-caption" [innerHTML]="element.ReminderMessage"></div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"
                [ngClass]="{
                  checked: selection.isSelected(row),
                  expanded: isExpanded(row),
                  collapsed: !isExpanded(row),
                  disabled: row.disabled
                }"
                class="one-element-row"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" 
                [ngClass]="{
                  checked: selection.isSelected(row),
                  expanded: isExpanded(row),
                  collapsed: !isExpanded(row),
                  disabled: row.disabled
                }"
                class="one-detail-row">
              </tr>
            </table>
            </one-table-content>
        </one-table>
        <div class="noDataViewReminder" *ngIf="dataSource.data.length < 1">
            <ng-container *ngIf="dataSource.data.length < 1;">
              No data available.
            </ng-container>
        </div>
      </div>
    </div>
    <div mat-dialog-actions oneDialogActions class="na-dialog-actions" style="display:flex">
        <button color="primary" mat-flat-button [mat-dialog-close]="false" class="mat-primary">Close</button>
    </div>
</div>
  